import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import DefaultCobrandUnitsPage from './Pages/DefaultCobrandUnitsPage';
import WizardPage from './Pages/WizardPage';
import SortSignupUnitsPage from './Pages/SortSignupUnitsPage';

const CobrandUnitsRouter = () => {
    let { path } = useRouteMatch();

    return (
        <Switch>
            {/* Must precede the :clientSchoolId route or "sort-order" is matched as an id. */}
            <Route path={`${path}/sort-order`}>
                <SortSignupUnitsPage />
            </Route>
            <Route path={`${path}/wizard`}>
                <WizardPage />
            </Route>
            <Route path={`${path}/:clientSchoolId/wizard`}>
                <WizardPage />
            </Route>
            <Route default>
                <DefaultCobrandUnitsPage />
            </Route>
        </Switch>
    );
};

export default CobrandUnitsRouter;
